export function getAdminLoginHashUrl(): string {
  const base = import.meta.env.BASE_URL.replace(/\/$/, "");
  return `${base}/#/admin/login`;
}

export function isOnAdminLoginRoute(): boolean {
  return window.location.hash.startsWith("#/admin/login");
}

export function redirectToAdminLoginHashRoute(): void {
  if (isOnAdminLoginRoute()) {
    return;
  }

  window.location.assign(getAdminLoginHashUrl());
}
